// @ts-check
// Config PÚBLICA validada (03-frontend.md §4.3). Todo valor aquí es público:
// nunca se colocan secretos en el bundle (§3 regla 8, §10.1).

/** @typedef {{ apiBaseUrl: string, environment: 'development'|'staging'|'production' }} PublicConfig */

/** @type {PublicConfig} */
export const config = Object.freeze({
  // Inyectado por el build por entorno; valor por defecto seguro para dev.
  apiBaseUrl: import.meta.env?.VITE_API_BASE_URL ?? '/api/v1',
  environment:
    /** @type {PublicConfig['environment']} */ (import.meta.env?.MODE) ?? 'development',
});
